var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"library-banner"},[_c('h4',{staticClass:"library-banner-text"},[_vm._v("\n    "+_vm._s(_vm.bannerText)+"\n  ")]),_vm._v(" "),_c('BaseButton',{staticClass:"button-white",attrs:{"large":"","elevation":"0"},on:{"click":_vm.openConnect}},[_vm._v("\n    "+_vm._s(_vm.$t('LibraryBanner.guest.btn'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }